import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const pageConfig = (window as any).pageConfig;

interface PageSettings {
    page: number,
    limit: number,
    pagination: boolean,
    categoriesText: string,
    noResultsText?: any,
    isLandingPage: string,
    sortType: string,
    sortDropdownLabel: string,
    alphabeticalSortLabel: string,
    reverseAlphabeticalSortLabel: string,
    chronologicalSortLabel: string,
    reverseChronologicalSortLabel: string
}

const initialState: PageSettings = {
    page: 0,
    limit: 3,
    pagination: true,
    sortType: pageConfig.sortType != null ? pageConfig.sortType : pageConfig.defaultSortOption,
    categoriesText: pageConfig.categoriesLabel != null ? pageConfig.categoriesLabel : "Categories",
    noResultsText: pageConfig.noResultsText != null ? pageConfig.noResultsText : null,
    isLandingPage: pageConfig.isLandingPage != null ? pageConfig.isLandingPage : "false",
    sortDropdownLabel: pageConfig.sortDropdownLabel,
    alphabeticalSortLabel: pageConfig.alphabeticalSortLabel,
    reverseAlphabeticalSortLabel: pageConfig.reverseAlphabeticalSortLabel,
    chronologicalSortLabel: pageConfig.chronologicalSortLabel,
    reverseChronologicalSortLabel: pageConfig.reverseChronologicalSortLabel
    
};

const pageSettingsSlice = createSlice({
    name: 'pageSettings',
    initialState,
    reducers: {
        initializeSettings(state) {
            state.categoriesText = pageConfig.categoriesLabel
        },
        setCurrentPage(state, action: PayloadAction<number>) {
            state.page = action.payload;
        },
        setPagination(state, action: PayloadAction<boolean>) {
            state.pagination = action.payload;
        },
        updateLimit(state, action: PayloadAction<number>) {
            state.page = action.payload;
        },
        setPage(state) {
            state.isLandingPage = pageConfig.isLandingPage;
        },
        setSortType(state, action: PayloadAction<string>) {
            state.page = 0;
            state.sortType = action.payload;
        }
    },
});

export const { initializeSettings, setCurrentPage, setPagination, updateLimit, setSortType } = pageSettingsSlice.actions;
export default pageSettingsSlice.reducer;
